import { Box } from '@mui/material';
import MuiCircularProgress from '@mui/material/CircularProgress';
import type { CircularProgressProps } from '@mui/material/CircularProgress';

export const CircularProgress = (props: CircularProgressProps) => (
  <MuiCircularProgress {...props} />
);

export const GradientCircularProgress = () => (
  <Box sx={{ position: 'relative', display: 'inline-flex' }}>
    {/* Invisible spinner base */}
    <CircularProgress
      size={16}
      thickness={5}
      sx={{
        color: 'transparent',
        '& .MuiCircularProgress-circle': {
          stroke: 'url(#gradientStroke)',
        },
      }}
    />
    {/* Inject SVG gradient once */}
    <svg width={0} height={0}>
      <defs>
        <linearGradient id="gradientStroke" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#19469D" />
          <stop offset="50%" stopColor="rgba(25, 70, 157, 1)" />
          <stop offset="80%" stopColor="rgba(25, 70, 157, 0.8)" />
          <stop offset="100%" stopColor="transparent" />
        </linearGradient>
      </defs>
    </svg>
  </Box>
);
